import { render, staticRenderFns } from "./ReferencesCr.vue?vue&type=template&id=5d292e48&scoped=true"
import script from "./ReferencesCr.vue?vue&type=script&lang=js"
export * from "./ReferencesCr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d292e48",
  null
  
)

export default component.exports